export default __webpack_public_path__ + "static/media/chatscarousel.c15dfb22.png";